import * as yup from "yup";
import "yup-phone";

export function getYupValidation(custom_fields, isMobile) {
  return {
    chatSubject: !isMobile
      ? yup.string().required("Subject is required")
      : undefined,
    name: yup
      .string()
      .max(50, "Name max length should not be more thatn 50")
      .required("Name is required"),
    email: yup.string().email().required("Email is required"),
    phoneNumber: yup
      .string()
      .phone("ID", true, "Phone numer is not valid")
      .required("Phone number is required"),
    idpel: custom_fields.find((el) => el.name == "idpel")
      ? yup
          .string()
          .matches(/^[0-9]+$/gi, "ID Pelanggan / No Meter is not valid")
          .test(
            "min-max-test",
            "ID Pelanggan / No Meter must be between 11 or 12 digit",
            (item) => {
              if (item) {
                return item.length >= 11 && item.length <= 12;
              } else return true;
            }
          )
          .nullable()
      : undefined,
    yourMessage: !isMobile
      ? yup
          .string()
          .max(300, "Limit your message below 300 chars")
          .required("Please type your message")
      : undefined,
  };
}
